import React from 'react';
import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, Tooltip, Legend, CartesianGrid, PieChart, Pie, Cell, BarChart, Bar } from 'recharts';
import { PALETTE, TYPE_LABEL, TIER_ORDER, ORANGE } from './trackerApi';

const AXIS = { fontSize: 11, fill: '#71717A' };
const TIP = { contentStyle: { borderRadius: 12, border: '1px solid rgba(0,0,0,0.08)', fontSize: 12 } };

export const WeeklyLines = ({ data, competitors, height = 280 }) => (
  <ResponsiveContainer width="100%" height={height}>
    <LineChart data={data} margin={{ top: 10, right: 16, left: -16, bottom: 0 }}>
      <CartesianGrid stroke="#F4F4F5" vertical={false} />
      <XAxis dataKey="week" tick={AXIS} axisLine={false} tickLine={false} />
      <YAxis allowDecimals={false} tick={AXIS} axisLine={false} tickLine={false} />
      <Tooltip {...TIP} />
      {competitors.length > 1 && <Legend iconType="circle" wrapperStyle={{ fontSize: 12 }} />}
      {competitors.map((c, i) => (
        <Line key={c.instagram_handle} type="monotone" dataKey={c.instagram_handle} name={c.name} stroke={PALETTE[i % PALETTE.length]}
          strokeWidth={2.5} strokeOpacity={1 - i * 0.12} dot={{ r: 3.5, strokeWidth: 0, fill: PALETTE[i % PALETTE.length] }} activeDot={{ r: 5 }} />
      ))}
    </LineChart>
  </ResponsiveContainer>
);

export const TypePie = ({ split }) => {
  const data = Object.entries(split).map(([k, v]) => ({ name: TYPE_LABEL[k], value: v })).filter((d) => d.value > 0);
  return (
    <ResponsiveContainer width="100%" height={220}>
      <PieChart>
        <Pie data={data} dataKey="value" nameKey="name" innerRadius={52} outerRadius={84} paddingAngle={3} stroke="none">
          {data.map((d, i) => <Cell key={d.name} fill={PALETTE[i]} />)}
        </Pie>
        <Tooltip {...TIP} />
        <Legend iconType="circle" wrapperStyle={{ fontSize: 12 }} />
      </PieChart>
    </ResponsiveContainer>
  );
};

export const TierBars = ({ split }) => (!Object.values(split).some(Boolean) ? (
  <div className="h-[220px] flex items-center justify-center text-center text-xs text-[#A1A1AA] px-6" data-testid="tier-chart-empty">Creator tiers need creator follower counts, which aren't collected yet.</div>
) : (
  <ResponsiveContainer width="100%" height={220}>
    <BarChart data={TIER_ORDER.map((t) => ({ tier: t, posts: split[t] || 0 }))} margin={{ top: 10, right: 10, left: -20, bottom: 0 }}>
      <CartesianGrid stroke="#F4F4F5" vertical={false} />
      <XAxis dataKey="tier" tick={AXIS} axisLine={false} tickLine={false} />
      <YAxis allowDecimals={false} tick={AXIS} axisLine={false} tickLine={false} />
      <Tooltip {...TIP} cursor={{ fill: 'rgba(255,69,26,0.06)' }} />
      <Bar dataKey="posts" fill={ORANGE} radius={[8, 8, 0, 0]} maxBarSize={48} />
    </BarChart>
  </ResponsiveContainer>
));
